import { useState } from "react";
import Modal from "react-modal";
import { isValidUrl } from "@hooks/ValidUrl";
import GroupImage from "@assets/images/Group 7.png";
import EmailIcon from "@assets/images/emailIcon.svg";
import RemoveIcon from "@assets/images/pajamas_remove.svg";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
import { toast } from "react-toastify";
import { getInvitedEmails, inviteMember } from "api/generalServices";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useTranslation } from "react-i18next";

const InviteMembers = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailsList, setEmailsList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslation();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const fetchEmails = async () => {
    try {
      const res = await getInvitedEmails();
      setEmailsList(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendEmail = async () => {
    if (!email.trim()) {
      toast.error(t("Email is required"));
      return;
    }

    // optional: validate email format
    if (!emailRegex.test(email)) {
      toast.error(t("Please enter a valid email address"));
      return;
    }
    setLoading(true);
    try {
      await inviteMember(email);
      toast.info(t("Invitaion sent succesfully"));
      setEmail("");
    } catch (error) {
      toast.info(t("Failed to sent invitation"));
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleSelectEmail = (selectedEmail) => {
    setEmail(selectedEmail);
    setShowDropdown(false);
  };
  return (
    <div className={`p-2 bg-white h-[377px] max-h-[100%] rounded-[12px]`}>
      {/* <div className="flex items-center justify-end mb-2">
          <button onClick={() => setShowModal(false)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" rx="12" fill="" />
              <path
                d="M16 8L8 16"
                stroke="#8392D0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 8L16 16"
                stroke="#8392D0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div> */}
      <div className="flex justify-center">
        <img
          src={GroupImage}
          className="w-[120px] h-[55px] object-cover my-3"
          alt={"Profile picture"}
        />
      </div>
      <h2 className="text-[18px] font-[600] text-[#0575E6] text-center font-Lato">
        {t("Invite members")}{" "}
      </h2>

      <p className="text-[12px] font-[400] text-[#2B2E45] text-center mt-1 mb-2">
        {t("Excited on Budget Fit Plan!")}{" "}
      </p>
      <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
        <div className="relative w-fit mx-auto my-10">
          <img
            src={EmailIcon}
            alt="Email"
            className="absolute left-3 top-6 transform -translate-y-1/2 w-[20px] h-[20px]"
          />
          <input
            required
            className="bg-[#D7D7D740] w-[290px] rounded-[8px] p-[10px] pl-10 placeholder:text-[#999]"
            placeholder={t("Email Address")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onClick={() => {
              setShowDropdown(true);
              fetchEmails();
            }}
          />
          {showDropdown && emailsList.length > 0 && (
            <ul className="absolute z-10 top-[45px] left-0 bg-white border border-gray-200 w-full rounded-[8px] max-h-[150px] overflow-y-auto shadow-md">
              {emailsList.map((item, index) => (
                <li
                  key={index}
                  className="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectEmail(item)}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
          <p className="text-[11px] font-[300] text-[#2B2E45] text-center font-Poppins mt-1">
            {t("Enter an email address to send an invite")}
          </p>
        </div>
      </ClickAwayListener>
      <div className="flex justify-center items-center gap-1 sm:gap-8 flex-col sm:flex-row">
        <button
          onClick={() => handleSendEmail()}
          className={`mt-4 px-[18px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] !text-white rounded-[32px] flex items-center justify-center gap-2 min-w-[280px] ${
            loading && "opacity-70"
          }`}
          disabled={loading}
        >
          {loading ? <ButtonLoader /> : t("Send Invitation")}
        </button>
      </div>
    </div>
  );
};

export default InviteMembers;
